import AddTestStepper from "../../components/add/AddTestStepper";
import {
  Box,
  Button,
  FormControlLabel,
  FormGroup,
  Switch,
  TextField,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  useTheme,
  Grid
} from "@mui/material";
import AddTestPageNavButtons from "./AddTestPageNavButtons";
import DragDropFileUpload from "./DragDropFileUpload";
import VideoCard, { LargeVideoCard } from "../global/VideoCard";
import { TestCard } from "../global/VideoCard";
import { tokens } from "../../theme";
import { useContext, useState } from "react";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import Typography from "@mui/material/Typography";
import { VideoContext } from "../../context/video_context";
import { LargeThumbnail } from "./Thumbnail";
import { ExpandMore } from "@mui/icons-material";
import moment from "moment";
import { toast } from "react-toastify";
import TestOptions from "../global/TestOptions";

type SelectVideos = {
  handlePageChangeUp: any;
  handlePageChangeDown: any;
  handlePageChange: any;
};

const activeStep: number = 2;

export default function TestSettings(fn: SelectVideos) {

  const videoContext = useContext(VideoContext);
  const selectedVideo = videoContext?.selectedVideo;
  const titles = videoContext?.titles || [];
  const setTitles = videoContext?.setTitles || (() => {
  });
  const files = videoContext?.files || [];
  const tests = videoContext?.tests || [];
  const loading = videoContext?.loading || false;
  const useOriginal = videoContext?.useOriginal || false;
  const setUseOriginal = videoContext?.setUseOriginal || (() => {
  });
  const alignment = videoContext?.alignment || null;
  const setAlignment = videoContext?.setAlignment || (() => {
  });
  const duration = videoContext?.duration || 0;
  const createTest = videoContext?.createTest || (() => Promise.resolve({}));
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  function handleFileUpload(file: any) {
    console.log(file);
  }

  function handleTitleChange(title: string) {
    const new_titles: any = titles.push(title);
    setTitles(new_titles);
    // console.log(new_titles);
  }

  const handleAlignment = (
    event: React.MouseEvent<HTMLElement>,
    newAlignment: string | null
  ) => {
    setAlignment(newAlignment);
  };

  return (
    <Box
      sx={{
        width: "100%",
        paddingY: 2,
        display: "flex",
        flexDirection: "column",
        height: "100%"
      }}
    >
      <AddTestStepper activeStep={activeStep} />
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          paddingY: 2
        }}
      >
        <Box sx={{ paddingX: 6, paddingY: 4, flexGrow: 1 }}>
          <Box sx={{ fontSize: "h4.fontSize", paddingBottom: 2 }}>
            Running {tests.length} tests until{" "}
            {moment(
              new Date(new Date().getTime() + tests.length * duration * 1000)
            ).format("h:mm a, ddd, MMM Do YYYY")}
          </Box>
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMore />}
              aria-controls="panel1-content"
              id="panel1-header"
              sx={{ fontSize: "h5.fontSize" }}
            >
              Advanced Settings
            </AccordionSummary>
            <AccordionDetails sx={{ padding: 2 }}>
              <TestOptions />
            </AccordionDetails>
          </Accordion>
          <Grid container spacing={2} sx={{ paddingY: 2 }}>
            {tests.map((test: any) => {
              return (
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  lg={4}
                  key={test.video_id}
                  style={{ minWidth: "326px" }}
                >
                  <TestCard {...test} />
                </Grid>
              );
            })}
          </Grid>
        </Box>
        <Box sx={{ marginLeft: "auto", padding: 6 }}>
          <VideoCard
            handlePageChangeUp={fn.handlePageChangeUp}
            views={selectedVideo?.views || "0"}
            uploaded={selectedVideo?.uploaded || new Date()}
            video_id={selectedVideo?.video_id || ""}
            title={selectedVideo?.title || ""}
            imgLink={selectedVideo?.imgLink || ""}
          />
          <Box sx={{ fontSize: "h4.fontSize", paddingY: 2 }}>Thumbnails</Box>
          <Box
            sx={{
              fontSize: "h4.fontSize",
              gap: 2,
              display: "flex",
              flexDirection: "column"
            }}
          >
            {files.map((file: any) => {
              return <LargeThumbnail image={URL.createObjectURL(file)} />;
            })}
          </Box>
        </Box>
      </Box>
      <AddTestPageNavButtons
        step={activeStep}
        nextTitle="Deploy"
        disabled={loading}
        handlePageChangeUp={() => {
          toast.promise(
            createTest().then(() => {
              fn.handlePageChange(0);
            }),
            {
              pending: "Creating Test...",
              success: "Test Created!",
              error: "Error creating test"
            }
          );
        }}
        handlePageChangeDown={fn.handlePageChangeDown}
      />
    </Box>
  );
}
